<template>
  <div class='signup-component result-component userinfo' v-show='shouldShowForm || shouldShowCompletion' :style='themeStyle'>
    <div class='signup-form-wrap' v-show='shouldShowForm'>
      <header class='subheading' :style='headingStyle'>
        <h1>{{$t(config.title, `options.components.${$attrs['data-index']}.options.title`)}}</h1>
      </header>
      <div class="result-signup--content">
        <section  :style='textStyle'>
          <div class="result-text" v-html='$t(config.text, `options.components.${$attrs["data-index"]}.options.text`)'></div>
        </section>
        <LeadForm :fields='signup.form.fields' :translationContexts='translationContexts' @signup='save' :show-copy='false' :buttonText='config.buttonText || signup.buttonText' :editable='false' :config='formConfig'></LeadForm>
      </div>
    </div>
    <div class='signup-form-complete' v-show='shouldShowCompletion'>
      <div class="result-signup--content">
        <header>
          <h1 v-html='$t(config.completed.title, `options.components.${$attrs["data-index"]}.options.completed.title`)'></h1>
        </header>
        <div class="result-text" v-html='$t(config.completed.message, `options.components.${$attrs["data-index"]}.options.completed.message`)'></div>
      </div>
    </div>
  </div>
</template>

<script>
import LeadForm from './LeadForm'
import chroma from 'chroma-js'
import TranslationMixin from '../lib/TranslationMixin'
export default {
  name: 'Signup',
  props: ['config', 'button-text', 'result'],
  components: {
    LeadForm
  },
  inject: ['theme'],
  mixins: [TranslationMixin],
  data: function () {
    return {
      first_name: '',
      last_name: '',
      company: '',
      email: '',
      tel_no: '',
      optin: false,
      errors: [],
      shouldShowForm: false,
      shouldShowCompletion: false,
      buttonStyles: {}
    }
  },
  created () {
    this.shouldShowForm = this.willShowForm()
    this.shouldShowCompletion = this.willShowCompletion()
    this.baseButtonStyles = this.theme.accent
    let hoverColor = chroma(this.theme.accent.color).darken().hex()
    let hoverBackgroundColor = chroma(this.theme.accent.backgroundColor).darken().hex()
    let hoverStyle = {color: hoverColor, backgroundColor: hoverBackgroundColor}
    this.hoverButtonStyles = hoverStyle
    this.buttonStyles = Object.assign({}, this.baseButtonStyles)
    let styleRule = `#${this.$attrs.id} a:link, #${this.$attrs.id} a:visited`
    this.stylesheet.addRule(styleRule, {color: this.themeStyle.color})
  },
  mounted () {
    setTimeout(this.retargetLinks, 500)
  },
  computed: {
    stylesheet () {
      return this.$store.state.stylesheet
    },
    headingStyle () {
      return {
        fontSize: this.config.titleFontSize + '%'
      }
    },
    textStyle () {
      return {
        fontSize: this.config.textFontSize + '%'
      }
    },
    translationContexts () {
      return {
        copy: `results-page.${this.$attrs.id}`,
        fields: 'signup.form.fields',
        errors: 'errors',
        signup: 'signup'
      }
    },
    componentStyle () {
      let style = {
        backgroundColor: this.config.backgroundColor,
        color: this.config.textColor
      }
      return style
    },
    themeStyle () {
      return {
        backgroundColor: this.config.backgroundColor || this.theme.secondary.backgroundColor,
        color: this.config.textColor || this.theme.secondary.color
      }
    },
    formConfig: function () {
      return {
        title: this.signup.form.title,
        enabledFields: this.signup.form.enabledFields,
        privacyStatement: this.signup.form.privacyStatement,
        buttonColor: this.config.buttonColor || this.theme.accent.backgroundColor,
        buttonTextColor: this.config.buttonTextColor || this.theme.accent.color
      }
    },
    signup: {
      get () {
        return this.$store.state.config.signup
      }
    },
    ctaText () {
      if (this.signup.mode === 'none') {
        return this.signup.cta
      }
      if (this.exists(this.signup.resultCTAText) && this.signup.resultCTAText !== '') {
        return this.signup.resultCTAText
      }
      return this.signup.cta
    },
    ctaButton () {
      if (this.signup.mode === 'none') {
        return this.signup.buttonText
      }
      if (this.exists(this.signup.resultCTAButton) && this.signup.resultCTAButton !== '') {
        return this.signup.resultCTAButton
      }
      return this.signup.buttonText
    }
  },
  watch: {
    shouldShowCompletion: function (show) {
      if (show === true) {
        setTimeout(this.retargetLinks, 250)
      }
    }
  },
  methods: {
    retargetLinks () {
      let links = this.$el.querySelectorAll('a')
      for (let link of links) {
        if (!link.href) {
          break
        }
        if (link.host !== location.host) {
          link.setAttribute('target', '_blank')
        }
      }
    },
    addHover (event) {
      this.buttonStyles = Object.assign({}, this.hoverButtonStyles)
    },
    removeHover (event) {
      this.buttonStyles = Object.assign({}, this.baseButtonStyles)
    },
    willShowForm () {
      if (!this.exists(this.config.show)) {
        return true
      }

      if (this.signup.mode === 'none') {
        return true
      }

      if (this.$store.state.signedUp === true) {
        return false
      }

      if (this.$store.state.signedUp === false && this.signup.mode === 'mandatory') {
        return true
      }

      if (this.config.show.key === 'barrier') {
        let noAnswer = typeof this.$store.state.answers.barrier === 'undefined'
        if (noAnswer) {
          return true
        }
        return this.$store.state.answers.barrier === 'No'
      }

      if (this.exists(this.config.show.condition)) {
        if (this.config.show.condition === 'if') {
          return this.$store.state.answers[this.config.show.key] === this.config.show.value
        }

        if (this.config.show.condition === 'ifNot') {
          return this.$store.state.answers[this.config.show.key] !== this.config.show.value
        }
      }

      return this.config.show
    },
    willShowCompletion () {
      if (this.config.show.key === 'barrier' && this.signup.mode === 'optional') {
        let noAnswer = typeof this.$store.state.answers.barrier === 'undefined'
        if (noAnswer) {
          return false
        }
        return this.$store.state.signedUp
      }

      if (this.$store.state.signedUp === true) {
        return true
      } else {
        return false
      }
    },
    errorClass (fieldName, extraClasses) {
      let classes = ['field']
      if (typeof extraClasses !== 'undefined') {
        classes.push(extraClasses)
      }
      classes.push(this.errors.includes(fieldName) ? 'invalid' : 'valid')
      return classes.join(' ')
    },
    save (form) {
      let userInfo = form.lead
      let extraInfo = form.extra
      if (Object.keys(extraInfo).length > 0) {
        this.saveExtraInfo(extraInfo).then((resp) => {
          this.saveUserInfo(userInfo).then((resp) => {
            this.$gtag.event('signup', {event_category: 'result', event_label: 'userPromoted', value: 1})
            this.onSignupCompleted()
          })
        })
      } else {
        this.saveUserInfo(userInfo).then((resp) => {
          this.$gtag.event('signup', {event_category: 'result', event_label: 'userPromoted', value: 1})
          this.onSignupCompleted()
        })
      }
    },
    saveExtraInfo (extraInfo) {
      return this.$store.dispatch('save', {key: '_userdata', answer: {value: extraInfo}})
    },
    saveUserInfo (userInfo) {
      return this.$store.dispatch('promoteUser', {key: this.config.key, answer: {value: userInfo}})
    },
    onSignupCompleted () {
      this.$emit('signedup')
      this.shouldShowForm = false
      this.shouldShowCompletion = true
      this.$emit('scroll', this.$el.id)
    }
  }
}
</script>

<style lang='scss'>
@import '../scss/base';
@import '../scss/components/checkbox';

.field.invalid {
  input {
    border-left:10px solid $error-red;
  }
}
a.next {
  @include button;
  display:block;
}
 .clearfix {
  padding-top:10px;
 }

 .signup-form-complete {
  text-align: center;
  h2 {
    margin-top: 0;
  }
 }
</style>

<style lang='scss' scoped>
  h2 {
    margin-top:0;
  }
</style>
